<template>
    <div class="project_modular ">
        <div id="visit_project_unit_echarts">
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-liquidfill";
import "@/util/echarts-auto-tooltip";

export default {
    name: 'visitProjectUnit',
    data() {
        return {
            chart: null,
            tooltipTimerGet: null,
        }
    },
    props: {
        dataInfo: {
            type: Object,
            default: () => {
                return [
                    
                ]
            }
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.tooltipTimer.clearLoop();
        this.chart.dispose();
        this.chart = null;
    },
    mounted() {
        // this.initChart();
    },
    methods: {
        initChart() {
            let that = this
            this.chart = echarts.init(
                document.getElementById("visit_project_unit_echarts")
            );
            window.addEventListener("resize", function () {
                if (that.chart) {
                    that.chart.resize();

                }
            });
            this.$nextTick(() => {
                this.getDetail();
            });
        },
        async getDetail() {


            let dataInfo=this.dataInfo
            let optionData = {
                xAxisData: dataInfo.map(item=>{
                    return item.createDeptName
                }),
                seriesData: dataInfo.map(item=>{
                    return item.visitCount
                })
            }
            this.setOptions(optionData);


        },
        setOptions({ xAxisData = [], seriesData = [] } = {}) {
            let option = {
               
                xAxis: {
                    data: xAxisData,
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        interval: 0, //使x轴文字显示全
                        // formatter: function (params) {
                        //     var newParamsName = "";
                        //     var paramsNameNumber = params.length;
                        //     var provideNumber = 4; //一行显示几个字
                        //     var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                        //     if (paramsNameNumber > provideNumber) {
                        //         for (var p = 0; p < rowNumber; p++) {
                        //             var tempStr = "";
                        //             var start = p * provideNumber;
                        //             var end = start + provideNumber;
                        //             if (p == rowNumber - 1) {
                        //                 tempStr = params.substring(start, paramsNameNumber);
                        //             } else {
                        //                 tempStr = params.substring(start, end) + "\n";
                        //             }
                        //             newParamsName += tempStr;
                        //         }
                        //     } else {
                        //         newParamsName = params;
                        //     }
                        //     return newParamsName;
                        // },

                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                legend: {},
                yAxis: {},
                series: [
                    {
                        type: "bar",
                        data: seriesData,
                        barWidth: 40,

                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0.43,
                                        color: "rgba(64, 158, 255,0.43)",
                                    },
                                    {
                                        offset: 1,
                                        color: "#409EFF",
                                    },
                                ]),

                                barBorderRadius: [7, 7, 0, 0],
                            },
                        },
                    },
                ],
                tooltip: {
                    formatter: "{b} : {c} ",
                    // formatter: function (v) {
                    //     // console.log(v);
                    //     let val = v[0].value.toFixed(2);
                    //     return `${v[0].name} : <span style="font-size: 16px;color: #000000;">${val}</span>%`;
                    // },
                    trigger: "axis",
                    axisPointer: {
                        type: "line",
                        lineStyle: {
                            color: "rgba(64, 158, 255,0.1)",
                            type: "solid",
                            width: 60,
                        },
                    },
                },
            }

            this.tooltipTimer =
                // = autoHover(this.chart, option, 3, 3000);
                // eslint-disable-next-line no-undef
                tools.loopShowTooltip(this.chart, option, {
                    loopSeries: true,
                });
            this.chart.setOption(option);
        },
        updateChart(){
            this.tooltipTimer.clearLoop();
            this.getDetail();
        }

    }

}
</script>
<style lang="scss" scoped>
$base_width: 1920;
$base_height: 1080;

@function vw($px) {
    @return ($px / $base_width) * 100vw;
}

@function vh($px) {
    @return ($px / $base_height) * 100vh;
}

.project_modular {

    height: vh(750);

    #visit_project_unit_echarts {
        width: 100%;
        height: vh(750);
    }


}
</style>
